export default __webpack_public_path__ + "static/media/exclamation-circle.35ff977a.svg";